import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import CollectionModal from './CollectionModal';
import useFeaturedCardData from '../hooks/useFeaturedCardData';
import disablePageScroll from '../actions/disablePageScroll';

const CollectionFeaturedCard = ({image, title, subtitle, id, alttext, lang}) => {
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [modalContent, setModalContent] = useFeaturedCardData();
	const [currentModalItemIndex, setCurrentModalItemIndex] = useState(null);
	disablePageScroll(modalIsOpen);
	const mainImage = JSON.parse(image);
	const placeholderImgSrc = `${mainScript.assetPath}images/png/placeholder/bmo-portrait-placeholder.png`;
	const [itemId, setItemId] = useState(null);

	useEffect(() => {
		if (modalContent.length && !itemId) {
			window.history.pushState({}, '', window.location.pathname);
		}
	}, [itemId]);

	const handleOpenModal = () => {
		setItemId(id);
		const itemIndex = modalContent.findIndex(item => item.id === id);
		setCurrentModalItemIndex(itemIndex);
		setModalIsOpen(true);
	};

	return (
		<>
			<button className='single-collection-page__card-button'
				data-modal-item-id={id}
				aria-controls={`modal-${id}`}
				onClick={handleOpenModal}
				onKeyDown={(event) => {
					if (event.key !== 'Enter') return;
					event.preventDefault();
					handleOpenModal();
				}}
			>
				<div className='aspect-ratio-box'>
					<img className='single-collection-page__card-img' src={mainImage.url ? mainImage.url : placeholderImgSrc} alt={alttext ? alttext : title}/>
				</div>
				<h3 className='single-collection-page__card-title' dangerouslySetInnerHTML={{__html: title}}></h3>
				<p className='single-collection-page__card-subtitle'>{subtitle}</p>
			</button>
			{
				modalContent.length > 0 && modalIsOpen
					? <CollectionModal 
						setModalIsOpen={setModalIsOpen}
						modalContent={modalContent[currentModalItemIndex]}
						setCurrentModalItemIndex={setCurrentModalItemIndex}
						modalContentLength={modalContent.length}
						currentModalItemIndex={currentModalItemIndex}
						setModalContent={setModalContent}
						language={lang}
						setItemId={setItemId}
					/>
					: null
			}
		</>
	)
}

export default CollectionFeaturedCard;

CollectionFeaturedCard.propTypes = {
	image: PropTypes.string,
	title: PropTypes.string,
	subtitle: PropTypes.string,
	id: PropTypes.string,
	alttext: PropTypes.string,
	lang: PropTypes.string,
}

